const formExtra = () =>{
    if(document.querySelector('.wpcf7-form')){
        document.addEventListener('input', ev =>{
            if(!ev.target.closest('.kruse-form-text-input-holder')) return;
            const holder = ev.target.closest('.kruse-form-text-input-holder');
            if(ev.target.value == ''){
                holder.classList.remove('kruse-form-text-input-holder-active');
            }else{
                holder.classList.add('kruse-form-text-input-holder-active');
            }

        })
    }
}
export default formExtra;